<template>
  <Dialog :common-dialog="addOnDialog" :dialog-width="dialog_width">
    <template v-slot:title>
      <v-layout>
        <v-flex>
          <span class="text-capitalize">Select </span>
        </v-flex>
        <v-flex class="text-right">
          <v-btn style="height: 32px !important" class="custom-bold-button mr-2" depressed color="cyan white--text"
            v-on:click="saveAddons()">Save</v-btn>
          <v-btn style="height: 32px !important" class="custom-bold-button" depressed
            v-on:click="$emit('close', true)">Close</v-btn>
        </v-flex>
      </v-layout>
    </template>
    <template v-slot:body>
      <v-card outlined class="rounded overflow-hidden mx-4 my-2">
        <v-simple-table dense fixed-header max-height="300">
          <thead>
            <tr style="background-color: #f4f4f4">
              <th class="font-weight-bold" width="60px">
                <v-checkbox
                  v-model="selectedAll"
                  :true-value="1"
                  :false-value="0"
                  color="cyan darken-2"
                  hide-details
                  dense
                ></v-checkbox>
              </th>
              <th class="font-weight-bold font-size-13">Name</th>
              <th class="font-weight-bold font-size-13">Price</th>
            </tr>
          </thead>

          <tbody v-if="addons && addons?.length">
            <tr v-for="(addon, index) in addons" :key="index" :class="index % 2 === 0 ? 'grey lighten-5' : ''"
              style="border-bottom: 1px solid #e0e0e0">
              <!-- Checkbox -->
              <td class="text-center">
                <v-checkbox v-model="addon.add_on_selected" :true-value="1" :false-value="0" color="cyan darken-2"
                  hide-details dense ></v-checkbox>
              </td>

              <!-- Name -->
              <td class="py-1 text-left">
                <v-text-field v-model="addon.name" dense solo flat readonly hide-details class="mx-auto"></v-text-field>
              </td>

              <!-- Price -->
              <td class="py-1 text-left">
                <v-text-field v-model="addon.price" dense solo flat hide-details type="number" class="mx-aut"
                  style="max-width: 90px"></v-text-field>
              </td>
            </tr>
          </tbody>

          <!-- Empty State -->
          <tbody v-else>
            <tr>
              <td colspan="3">
                <div class="text-center py-6">
                  <img :src="$assetURL('media/error/empty.png')" height="90" class="mx-auto mb-3" />
                  <div class="font-weight-medium grey--text">
                    Uhh... There are no Addons at this moment.
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-card>
    </template>
  </Dialog>
</template>
<script>
import Dialog from "@/view/pages/partials/Dialog.vue";
export default {
  name: "line-item-dialog-v2",
  props: {
    addOnDialog: {
      type: Boolean,
      default: false,
    },
    addons: {
      type: [Array, Object],
      default: () => [],
    },
  },
  data() {
    return {
      selectedAll: 0,
      search: null,
      category: "all",
      house_type: "all",
      alphabet: "all",

      filter_categoty: null,
      filter_house_type: null,
    };
  },
  watch: {
    // Select All → update all rows
    selectedAll(val) {
      this.addons.forEach((addon) => {
        addon.add_on_selected = val;
      });
    },

    // Rows → update Select All
    addons: {
      handler(list) {
        const all = list?.length && list.every((a) => a.add_on_selected == 1);
        this.selectedAll = all ? 1 : 0;
      },
      deep: true,
    },
  },
  components: {
    Dialog,
  },
  computed: {
    dialog_width() {
      return this.lodash.toSafeInteger((document.body.clientWidth / 100) * 35);
    },
  },
  methods: {
    saveAddons() {
      this.$emit("addAddonToService", this.addons);
      this.$emit("update:addOnDialog", false);
    },
  
  },
  mounted() { },
};
</script>
<style scoped>
.custom_row {
  border-bottom: 1.5px solid #dbd7d7;
}

.custom_row:nth-child(even) {
  background: #fff4de;
}

.custom_row:hover {
  background: #fff4de;
}
</style>
